import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegionDropdownComponent } from './region-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [RegionDropdownComponent],
  exports: [RegionDropdownComponent],
})
export class RegionDropdownModule { }
